import { render, staticRenderFns } from "./Participa.vue?vue&type=template&id=dbc5e3e0&scoped=true&lang=pug&"
import script from "./Participa.vue?vue&type=script&lang=js&"
export * from "./Participa.vue?vue&type=script&lang=js&"
import style0 from "./Participa.vue?vue&type=style&index=0&id=dbc5e3e0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc5e3e0",
  null
  
)

export default component.exports